import { get } from 'svelte/store';
import { t } from 'svelte-i18n';

export enum NiveauEducationKYCEnum {
    AUCUN = 'AUCUN',
    CAP_BEP = 'CAP_BEP',
    BACCALAUREAT = 'BACCALAUREAT',
    DEUG_BTS_DUT_DEUST = 'DEUG_BTS_DUT_DEUST',
    LICENCE_PRO = 'LICENCE_PRO',
    MASTER1 = 'MASTER1',
    MASTER2 = 'MASTER2',
    DOCTORAT = 'DOCTORAT',
}

export const getNiveauEducationKYCString = (e: NiveauEducationKYCEnum): string => {
    const $t = get(t);
    switch (e) {
        case NiveauEducationKYCEnum.AUCUN:
            return $t('kyc.inputs.education.aucun');
        case NiveauEducationKYCEnum.CAP_BEP:
            return $t('kyc.inputs.education.cap');
        case NiveauEducationKYCEnum.BACCALAUREAT:
            return $t('kyc.inputs.education.bac');
        case NiveauEducationKYCEnum.DEUG_BTS_DUT_DEUST:
            return $t('kyc.inputs.education.deug');
        case NiveauEducationKYCEnum.LICENCE_PRO:
            return $t('kyc.inputs.education.licence');
        case NiveauEducationKYCEnum.MASTER1:
            return $t('kyc.inputs.education.master1');
        case NiveauEducationKYCEnum.MASTER2:
            return $t('kyc.inputs.education.master2');
        case NiveauEducationKYCEnum.DOCTORAT:
            return $t('kyc.inputs.education.doctorat');
        default:
            return '';
    }
};
